import React, { useEffect, useMemo, useState } from 'react';

import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faCheck } from '@fortawesome/free-solid-svg-icons';

import { sharePlatforms } from '../utils/constants/socialIcons';

function openShareWindow(url) {
  window.open(url, '_blank', 'width=600,height=500');
}

function ShareModalContent() {
  const shareUrl = useMemo(() => `${window.location.origin}/?ref=share`, []);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (!isCopied) return undefined;
    const timeoutId = window.setTimeout(() => setIsCopied(false), 2000);
    return () => window.clearTimeout(timeoutId);
  }, [isCopied]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setIsCopied(true);
    } catch (error) {
      console.error(error);
      openShareWindow(shareUrl);
    }
  };

  return (
    <div className="d-flex flex-column gap-3 text-center">
      <div>
        <p className="mb-1 text-secondary fw-semibold">Help spread the word about Spitface Battles.</p>
        <p className="small mb-0 text-secondary opacity-75">
          Share the beta roles page with your community.
        </p>
      </div>



      <div className="d-flex gap-5 flex-wrap justify-content-center">
        {sharePlatforms.map(({ platform, label, logo, color, SocialShareButton }) => (
          <SocialShareButton
            key={`share-button-${platform}`}
            title="Spitface Battles Beta Registration"
            htmlTitle="Spitface Battles"
            via="SpitfaceBattles"
            url={shareUrl}
            aria-label={`Share on ${label}`}
          >
            <img
              fetchpriority="low"
              src={logo}
              alt={platform}
              style={{ width: 48, height: 48 }}
            />
          </SocialShareButton>
        ))}

        <Button
          color="transparent"
          onClick={handleCopyLink}
          className="p-0 border-0 rounded-circle text-light"
        >
          <FontAwesomeIcon icon={(isCopied ? faCheck : faLink)} className="rounded-circle" style={{ width: 48, height: 48 }} />
        </Button>
      </div>
    </div>
  );
}

export default ShareModalContent;

